import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useGenderPackingQuery } from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";

const COLORS = ["#FFD700", "#556B2F", "#EF476F", "#8338EC", "#3A86FF",];

function GenderChart() {
  const { data, isLoading, error } = useGenderPackingQuery();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (data) {
      const genderStats = [
        {
          name: "Male",
          value: data?.data?.MALE?.count || 0,
          percentage: data?.data?.MALE?.percentage || 0,
        },
        {
          name: "Female",
          value: data?.data?.FEMALE?.count || 0,
          percentage: data?.data?.FEMALE?.percentage || 0,
        },
        {
          name: "Other",
          value: data?.data?.OTHER?.count || 0,
          percentage: data?.data?.OTHER?.percentage || 0,
        },
      ];
      setChartData(genderStats);
    }
  }, [data]);

  if (isLoading) return <LoaderSpiner />;
  if (error) return <p>Error loading data. Please try again later.</p>;


  const total = data?.data?.total;

  return (
    <div className="w-full h-full min-h-[300px] flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4 w-full">
        <div className="w-[200px] h-[200px] sm:w-[220px] sm:h-[220px] relative">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius="60%"
                outerRadius="85%"
                startAngle={90}
                endAngle={450}
                dataKey="value"
                strokeWidth={0}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: "#F9FAFB",
                  color: "#333",
                  borderRadius: "8px",
                  padding: "8px",
                  fontSize: "14px",
                  zIndex: 9999,
                }}
                labelStyle={{
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
                formatter={(value, name, props) => [
                  `${value} (${props.payload.percentage}%)`,
                  name,
                ]}
              />
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-0">
            <span className="text-xl sm:text-2xl font-bold z-0">{total}</span>
          </div>
        </div>

        {/* Legend */}
        <div className="flex justify-center items-center flex-wrap gap-4 mt-4">
          {chartData.map((entry, index) => (
            <div key={entry?.name} className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              ></div>
              <span className="text-sm">{entry?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


export default GenderChart;
